import DOMPurify from 'dompurify'

/**
 * Sanitize untrusted HTML before injecting via dangerouslySetInnerHTML.
 *
 * Question/answer content is authored by teachers but rendered in students'
 * browsers, so it must be treated as untrusted: without sanitization a
 * malicious or compromised teacher account could embed <script> / onerror
 * handlers to steal the student's JWT from localStorage.
 *
 * Strips scripts, event handlers and javascript: URLs while keeping the
 * formatting tags a rich-text editor produces.
 */
export function sanitizeHtml(dirty) {
  if (dirty == null) return ''
  return DOMPurify.sanitize(String(dirty), { USE_PROFILES: { html: true } })
}

/**
 * Sanitize, then collapse to plain text — for contexts that can't render
 * markup at all (native <option> children; a browser always shows an
 * <option>'s content as literal text, so any tags in it would otherwise
 * appear on-screen verbatim, e.g. the legacy import's boilerplate
 * `<style>img{...}</style>` / `<br>` prefix every option/answer carries).
 */
export function stripHtml(dirty) {
  if (dirty == null) return ''
  const clean = DOMPurify.sanitize(String(dirty), { USE_PROFILES: { html: true } })
  const el = document.createElement('div')
  el.innerHTML = clean
  return (el.textContent || '').trim()
}
